import { gql } from "@apollo/client";

export const GET_CASE_SCHEDULES = gql`
  query GetCaseSchedules($caseId: String!) {
    getAllCaseScheduleByCaseId(caseId: $caseId) {
      id
      title
      createdAt
      date
      time
      duration
      status
      location
      locationDetails
      orgId
      caseId
    }
  }
`;
